import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31')
];

export const server_loads = [0,3,4];

export const dictionary = {
		"/(app)/[language=language]": [~7,[2,3]],
		"/(app)/[language=language]/(account)/account": [~8,[2,3,4]],
		"/(app)/[language=language]/(account)/account/orders": [9,[2,3,4]],
		"/(app)/[language=language]/(account)/account/orders/[orderId]": [10,[2,3,4]],
		"/(app)/[language=language]/(account)/account/password": [~11,[2,3,4]],
		"/(app)/[language=language]/(account)/account/settings": [12,[2,3,4]],
		"/(app)/[language=language]/(legal)/agb": [22,[2,3]],
		"/(app)/[language=language]/(shop)/cart": [25,[2,3]],
		"/(app)/[language=language]/(shop)/checkout": [~26,[2,3,6]],
		"/(app)/[language=language]/(shop)/checkout/error": [~27,[2,3,6]],
		"/(app)/[language=language]/(shop)/checkout/success": [~28,[2,3,6]],
		"/(app)/[language=language]/(account)/guest/orders": [~13,[2,3,5]],
		"/(app)/[language=language]/(account)/guest/orders/[orderId]": [~14,[2,3,5]],
		"/(app)/[language=language]/(legal)/impressum": [23,[2,3]],
		"/(app)/[language=language]/(account)/login": [~15,[2,3]],
		"/(app)/[language=language]/(account)/login/forgot-password": [~16,[2,3]],
		"/(app)/[language=language]/(account)/login/forgot-password/success": [17,[2,3]],
		"/(app)/[language=language]/(legal)/privacy": [24,[2,3]],
		"/(app)/[language=language]/(shop)/product/TICKET-WWN": [29,[2,3]],
		"/(app)/[language=language]/(shop)/product/[productSlug=slug]": [30,[2,3]],
		"/(app)/[language=language]/(account)/recover/password": [~18,[2,3]],
		"/(app)/[language=language]/(account)/register": [~19,[2,3]],
		"/(app)/[language=language]/(account)/register/confirmation": [20,[2,3]],
		"/(app)/[language=language]/(account)/register/verification": [21,[2,3]],
		"/(app)/[language=language]/(shop)/search": [31,[2,3]]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),

	reroute: (() => {})
};

export { default as root } from '../root.svelte';